import { TranslateObject } from '@lumapps/translations';
import { WIDGET_CONTRIBUTION_TYPE } from '@lumapps/widget-contribution/constants';
import { WIDGET_HELP_TYPE } from '@lumapps/widget-help/constants';
import { WIDGET_HTML_TYPE } from '@lumapps/widget-html/constants';
import { WIDGET_INTRO_TYPE } from '@lumapps/widget-intro/constants';
import { WIDGET_SUMMARY_TYPE } from '@lumapps/widget-summary/constants';

/** Get the body translations of a textual widget (except the widget title) */
export const getWidgetBodyTranslations = (
    widgetType: string,
    properties?: any,
): { translations: TranslateObject<any> | undefined; key: string } | undefined => {
    if (!properties) {
        return undefined;
    }

    switch (widgetType) {
        case WIDGET_CONTRIBUTION_TYPE:
            return { translations: properties.richText, key: 'richText' };
        case WIDGET_SUMMARY_TYPE:
            return { translations: properties.text?.translations, key: 'text.translations' };
        case WIDGET_INTRO_TYPE:
        case WIDGET_HTML_TYPE:
        case WIDGET_HELP_TYPE:
            return { translations: properties.content, key: 'content' };
        default:
            return undefined;
    }
};
